import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { RegularRate, orientationFactor, orientationRate } from 'app/models/Placement/PlacementMods';
import { isNumber } from '../../../ModificationsUtils';
import { getCalculatedAmount } from './BillOvertime';
import { validDecimal } from 'app/helpers/numberHelper';

export const getFactorCalculatedAmount = (getValues, factor) => {
  const helperDiv = (
    <>
      <span>
        (Amount = ${getValues(factor) ? parseFloat(getValues(RegularRate)) * parseFloat(getValues(factor)) : '0.00'})
      </span>
    </>
  );

  return helperDiv;
};

export const getInvalidAmount = () => {
  const helperDiv = (
    <>
      <span>(Amount = '0.00')</span>
    </>
  );

  return helperDiv;
};

export const BillOrientation = ({ classes, isModEdit }: { classes: any; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const regularRateValue = useWatch<string>({ name: RegularRate });

  return (
    <Grid item className={classes.flex}>
      <Controller
        name={orientationRate}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={getValues(orientationRate)}
            className={classes.billFactorTextfields}
            InputLabelProps={{
              shrink: getValues(orientationRate),
            }}
            variant="filled"
            label={`${t(`placement.placementMods.${orientationRate}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, orientationRate) : getInvalidAmount()}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                setValue(orientationRate, e.target.value);
                onChange(e.target.value);
                setValue(orientationFactor, '');
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },

              startAdornment: (
                <>
                  {getValues(orientationRate) && (
                    <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>
                  )}
                </>
              ),
              sx: { fontSize: '14px' },
            }}
            {...rest}
          />
        )}
      />
      <div className={classes.middleText}>{'OR'}</div>
      <Grid>
        <Controller
          name={orientationFactor}
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <TextField
              value={getValues(orientationFactor)}
              variant="filled"
              label={`${t(`placement.placementMods.${orientationFactor}`)}`}
              helperText={
                regularRateValue ? getFactorCalculatedAmount(getValues, orientationFactor) : getInvalidAmount()
              }
              className={classes.billFactorTextfields}
              InputLabelProps={{
                shrink: getValues(orientationFactor),
              }}
              onChange={e => {
                if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                  setValue(orientationFactor, e.target.value);
                  onChange(e.target.value);
                  setValue(orientationRate, '');
                }
              }}
              InputProps={{
                readOnly: !isModEdit,
                style: {
                  pointerEvents: isModEdit ? 'auto' : 'none',
                },
                startAdornment: (
                  <>
                    {isNumber(getValues(orientationFactor)) && (
                      <InputAdornment position="start">
                        <CloseIcon className={classes.iconClass} />
                      </InputAdornment>
                    )}
                  </>
                ),
              }}
              {...rest}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
